import React from 'react';
import { Link, LinkProps } from 'pounceV2';

const OriginalReactLinkify = React.lazy(
  () => import(/* webpackChunkName: "linkify" */ 'linkify-react'),
);

const linkifyOptions = {
  defaultProtocol: 'https',
  tagName: () => Link,
  attributes: {
    external: true,
    wordBreak: 'break-word',
    size: 'small',
  } as LinkProps,
  target: (href, type) => type === 'url' && '_blank',
  className: 'linkified',
};

const LinkifyV3: React.FC<React.ComponentProps<typeof OriginalReactLinkify>> = ({
  children,
  options,
  ...rest
}) => {
  // caller can pass in options, which might have attributes. extract those out
  // to merge them with the linkify attributes that we always want present
  const { attributes: optionAttributes, ...otherOptions } = options ?? {};
  const passAttributes = { ...linkifyOptions.attributes, ...optionAttributes };
  const linkifyOpts = { ...linkifyOptions, attributes: passAttributes, ...otherOptions };
  return (
    <React.Suspense fallback={<span>{children}</span>}>
      <OriginalReactLinkify tagName="span" options={linkifyOpts} {...rest}>
        {children}
      </OriginalReactLinkify>
    </React.Suspense>
  );
};

export default LinkifyV3;
